export default function PageHeader({ label, title, children, accent }) {
  return (
    <div style={accent ? { borderLeft: `4px solid ${accent}` } : undefined}
      className="min-h-16 border-b border-border flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 px-4 sm:px-8 py-3 sm:py-0 static lg:sticky lg:top-0 bg-background/90 backdrop-blur z-10">
      <div className="reveal-fade">
        <p className="label-caps leading-none mb-1">{label}</p>
        <h1 className="font-heading text-xl font-bold tracking-tight leading-none">{title}</h1>
      </div>
      {children && <div className="flex flex-wrap items-center gap-2 sm:gap-3">{children}</div>}
    </div>
  );
}
